<template>
  <div class="row">
    <div class="col-md-6">
      <validation-provider
          :vid="`jala-province-and-regency-select-ajax.province`"
          :name="$t('customers.regions.province') + ' kantor'"
          v-slot="{ validated, errors }"
          :rules="rules.province"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="`${lodash.startCase($t('customers.regions.province'))} Kantor`"
            :state="errors[0] ? false : (validated ? true : null)"
            class="row mb-3"
            label-class="required-indicator"
            label-cols-md="12"
        >
          <multiselect-ajax
              :key="`${_uid}-province`"
              :name="`province`"
              :value="provinceValue"
              @input="onInput"
              :selected.sync="province"
              :url="'/jala/provinces?country_id__in=' + (countryId || 'ID')"
              :disabled="provinceDisabled"
          >
          </multiselect-ajax>
        </b-form-group>
      </validation-provider>
    </div>
    <div class="col-md-6">
      <validation-provider
          :vid="`jala-province-and-regency-select-ajax.regency`"
          :name="$t('customers.regions.regency') + ' kantor'"
          v-slot="{ validated, errors }"
          :rules="rules.regency"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="`${lodash.startCase($t('customers.regions.regency'))} Kantor`"
            :state="errors[0] ? false : (validated ? true : null)"
            class="row mb-3"
            label-class="required-indicator"
            label-cols-md="12">
          <multiselect-ajax
              :disabled="regencyDisabled || !provinceValue"
              :key="`${_uid}-select-regencies-${provinceValue}`"
              name="regency_id"
              :value="regencyValue" @input="(v) => onInput(v || provinceValue)"
              :selected.sync="regency"
              :url="`/jala/provinces/${provinceValue}/regencies`">
          </multiselect-ajax>
        </b-form-group>
      </validation-provider>
    </div>
    <div class="col-md-6">
      <validation-provider
          :vid="`jala-province-and-regency-select-ajax.district`"
          :name="$t('customers.regions.regency') + ' kantor'"
          v-slot="{ validated, errors }"
          :rules="rules.district"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="`${lodash.startCase($t('customers.regions.district'))} Kantor`"
            :state="errors[0] ? false : (validated ? true : null)"
            class="row mb-3"
            label-class="required-indicator"
            label-cols-md="12">
          <multiselect-ajax
              :key="`${_uid}-select-regencies-${regencyValue}`"
              :disabled="districtDisabled || !regencyValue"
              :selected.sync="district"
              :url="`/jala/regencies/${regencyValue}/districts`"
              :value="districtValue"
              name="regency_id"
              @input="(v) => onInput(v || regencyValue)">
          </multiselect-ajax>
        </b-form-group>
      </validation-provider>
    </div>
    <div class="col-md-6">
      <validation-provider
          :vid="`jala-province-and-regency-select-ajax.vilage`"
          :name="$t('customers.regions.village') + ' kantor'"
          v-slot="{ validated, errors }"
          :rules="rules.village"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="`${lodash.startCase($t('customers.regions.village'))} Kantor`"
            :state="errors[0] ? false : (validated ? true : null)"
            class="row mb-3"
            label-class="required-indicator"
            label-cols-md="12">
          <multiselect-ajax
              :key="`${_uid}-select-regencies-${districtValue}`"
              :disabled="villageDisabled || !districtValue"
              :selected.sync="village"
              :url="`/jala/districts/${districtValue}/villages`"
              :value="villageValue"
              name="regency_id"
              @input="(v) => onInput(v || districtValue)">
          </multiselect-ajax>
        </b-form-group>
      </validation-provider>
    </div>
  </div>
</template>

<script>
import MultiselectAjax from "@/components/inputs/vue-multiselect-ajax.vue";

export default {
  name: "jala-region-select-ajax",
  components: {
    MultiselectAjax
  },
  props: {
    value: {
      type: String,
      default: undefined
    },
    countryId: {
      type: String,
      default: 'ID'
    },
    regions: {
      type: Array,
      default: () => [
        'province',
        'regency',
        'district',
        'village'
      ]
    },
    rules: {
      type: Object,
      default: () => ({
        province: '',
        regency: ''
      })
    },
    disables: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      province: null,
      regency: null,
      district: null,
      village: null
    }
  },
  computed: {
    provinceDisabled() {
      return this.disables.includes('province');
    },
    regencyDisabled() {
      return this.disables.includes('regency');
    },
    districtDisabled() {
      return this.disables.includes('district');
    },
    villageDisabled() {
      return this.disables.includes('village');
    },
    provinceValue() {
      return (this.value || '').slice(0, 2);
    },
    regencyValue() {
      const regencyId = (this.value || '').slice(0, 4);
      return regencyId.length === 4 ? regencyId : '';
    },
    districtValue() {
      const districtId = (this.value || '').slice(0, 7);
      return districtId.length === 7 ? districtId : '';
    },
    villageValue() {
      const villageId = (this.value || '').slice(0, 10);
      return villageId.length === 10 ? villageId : '';
    }
  },
  watch: {
    province(event) {
      if (!event)
        this.regency = null;
      this.$nextTick(() => {
        this.$emit('update:selected', event)
      })
    },
    regency(event) {
      if (!event)
        this.district = null;
      this.$nextTick(() => {
        this.$emit('update:selected', event || this.province)
      })
    },
    district(event) {
      if (!event)
        this.village = null;
      this.$nextTick(() => {
        this.$emit('update:selected', event || this.regency)
      })
    },
    village(event) {
      if (!event)
        this.regency = null;
      this.$emit('update:selected', event || this.district)
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event)
    },
    clearAll() {
      this.$emit('input', undefined)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  legend.required-indicator::after {
    content: '*';
    color: red;
  }
}
</style>
